import React from 'react'
import classNames from 'classnames'
import { ShapeProps } from '../../FloatingShapesBackground.types'
import css from './Burst.styles.scss'

const Burst: React.FC<ShapeProps> = ({ animated }) => (
  <svg
    className={classNames(css.Burst, {
      [css.Burst__Animated]: animated,
    })}
    fill="none"
    height="148"
    id="burst"
    viewBox="0 0 188 188"
    width="148"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M89.1491 2.38198L75.3553 25.9775L51.0512 12.8811C47.8672 11.166 44.0006 13.4602 43.9901 17.0814L43.8422 44.4137L16.2462 45.2239C12.6312 45.3306 10.4297 49.2507 12.2313 52.392L25.7688 76.1357L2.27495 90.6354C-0.802394 92.5354 -0.748877 97.031 2.38198 98.8507L25.9781 112.645L12.8819 136.948C11.1668 140.132 13.4609 143.999 17.0822 144.009L44.4134 144.157L45.2237 171.753C45.3304 175.368 49.2505 177.57 52.3918 175.768L76.1356 162.231L90.6357 185.725C92.5356 188.802 97.0313 188.749 98.8509 185.618L112.645 162.022L136.949 175.118C140.133 176.833 144 174.539 144.01 170.918L144.158 143.586L171.754 142.776C175.369 142.669 177.571 138.749 175.769 135.608L162.231 111.864L185.725 97.3642C188.802 95.4643 188.749 90.9687 185.618 89.149L162.022 75.355L175.118 51.0508C176.834 47.8668 174.539 44.0002 170.918 43.9898L143.586 43.8418L142.776 16.2459C142.669 12.6309 138.749 10.4294 135.608 12.231L111.864 25.7687L97.3643 2.27494C95.4643 -0.802393 90.9687 -0.748875 89.1491 2.38198Z"
      fill="url(#paint0_linear_4569_48394)"
    />
    <path
      d="M89.1491 2.38198L75.3553 25.9775L51.0512 12.8811C47.8672 11.166 44.0006 13.4602 43.9901 17.0814L43.8422 44.4137L16.2462 45.2239C12.6312 45.3306 10.4297 49.2507 12.2313 52.392L25.7688 76.1357L2.27495 90.6354C-0.802394 92.5354 -0.748877 97.031 2.38198 98.8507L25.9781 112.645L12.8819 136.948C11.1668 140.132 13.4609 143.999 17.0822 144.009L44.4134 144.157L45.2237 171.753C45.3304 175.368 49.2505 177.57 52.3918 175.768L76.1356 162.231L90.6357 185.725C92.5356 188.802 97.0313 188.749 98.8509 185.618L112.645 162.022L136.949 175.118C140.133 176.833 144 174.539 144.01 170.918L144.158 143.586L171.754 142.776C175.369 142.669 177.571 138.749 175.769 135.608L162.231 111.864L185.725 97.3642C188.802 95.4643 188.749 90.9687 185.618 89.149L162.022 75.355L175.118 51.0508C176.834 47.8668 174.539 44.0002 170.918 43.9898L143.586 43.8418L142.776 16.2459C142.669 12.6309 138.749 10.4294 135.608 12.231L111.864 25.7687L97.3643 2.27494C95.4643 -0.802393 90.9687 -0.748875 89.1491 2.38198Z"
      fill="url(#paint1_radial_4569_48394)"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_4569_48394"
        x1="94"
        x2="94.3928"
        y1="5.44963e-06"
        y2="187.999"
      >
        <stop stopColor="#FFD43E" />
        <stop offset="0.5" stopColor="#56BB6C" />
        <stop offset="1" stopColor="#A0DCFF" />
      </linearGradient>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(188 93.9998) rotate(180) scale(188)"
        gradientUnits="userSpaceOnUse"
        id="paint1_radial_4569_48394"
        r="1"
      >
        <stop offset="0.1" stopColor="white" stopOpacity="0.9" />
        <stop offset="0.9" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
)

export default Burst
